import React from "react";
import {cn} from "../utils";

const SparklesIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="25"
        width="24"
        viewBox="0 0 24 25"
        className={cn(className)}
        xmlns="http://www.w3.org/2000/svg">
        <g clipRule="evenodd" fill={color || "currentColor"} fillRule="evenodd">
            <path
                d="m15 2.0271c.3507 0 .6546.24305.7317.58518l.5387 2.39158c.3933 1.74602 1.7568 3.10953 3.5028 3.50284l2.3916.53873c.3422.07707.5852.38096.5852.73167 0 .3507-.243.6546-.5852.7317l-2.3916.5387c-1.746.3933-3.1095 1.7568-3.5028 3.5028l-.5387 2.3916c-.0771.3422-.381.5852-.7317.5852s-.6546-.243-.7317-.5852l-.5387-2.3916c-.3933-1.746-1.7568-3.1095-3.5028-3.5028l-2.39162-.5387c-.34213-.0771-.58518-.381-.58518-.7317 0-.35071.24305-.6546.58518-.73167l2.39162-.53873c1.746-.39331 3.1095-1.75682 3.5028-3.50284l.5387-2.39158c.0771-.34213.381-.58518.7317-.58518zm0 3.98091c-.6156 1.76397-2.0051 3.15352-3.7691 3.76909 1.764.6156 3.1535 2.0051 3.7691 3.7691.6156-1.764 2.0051-3.1535 3.7691-3.7691-1.764-.61557-3.1535-2.00512-3.7691-3.76909z"/>
            <path
                d="m7 12.0271c.35071 0 .6546.243.73167.5852l.3848 1.7083c.26276 1.1664 1.17365 2.0773 2.34003 2.34l1.7083.3848c.3422.0771.5852.381.5852.7317s-.243.6546-.5852.7317l-1.7083.3848c-1.16638.2627-2.07727 1.1736-2.34003 2.34l-.3848 1.7083c-.07707.3422-.38096.5852-.73167.5852s-.6546-.243-.73167-.5852l-.3848-1.7083c-.26276-1.1664-1.17365-2.0773-2.34008-2.34l-1.70827-.3848c-.34213-.0771-.58518-.381-.58518-.7317s.24305-.6546.58518-.7317l1.70827-.3848c1.16643-.2627 2.07732-1.1736 2.34008-2.34l.3848-1.7083c.07707-.3422.38096-.5852.73167-.5852zm0 3.616c-.45051.9306-1.20342 1.6835-2.13397 2.134.93055.4505 1.68346 1.2034 2.13397 2.134.45051-.9306 1.20342-1.6835 2.13397-2.134-.93055-.4505-1.68346-1.2034-2.13397-2.134z"/>
        </g>
    </svg>
);

export {SparklesIcon};